// Browser build stub for @newaydata/capacitor-tile-server.
// In the browser the SPA fetches tiles straight from efb-app-server's
// /tiles/ route (HTTP Range), so no in-process tile server runs.

import { makeFail } from "./_fail";
const FAIL = makeFail("@newaydata/capacitor-tile-server");

export const TileServerPlugin = {
  async configure(_opts: unknown): Promise<void> {
    /* no-op on browser — tiles come from efb-app-server over HTTP */
  },
  async start(_opts?: unknown): Promise<{ baseUrl: string }> {
    // efb-app-server's `/tiles/` route serves from <dataDir>/updates/, which
    // mirrors mobile's `Directory.Data` root after the update lib strips the
    // producer's `data/` wrapper. Returning `/tiles` (no trailing slash; the
    // call site appends a `/`) means relative URLs like `base/512/{z}/{x}/{y}.jpg`
    // resolve to `/tiles/base/512/{z}/{x}/{y}.jpg` — same shape on both targets.
    return { baseUrl: "/tiles" };
  },
  async stop(): Promise<void> {
    /* no-op */
  },
  async addSource(_opts: unknown): Promise<unknown> {
    return FAIL("TileServerPlugin.addSource");
  },
  async removeSource(_opts: unknown): Promise<unknown> {
    return FAIL("TileServerPlugin.removeSource");
  },
  async listSources(): Promise<{ sources: string[] }> {
    return { sources: [] };
  },
};
